/**
 * Deferred-work port — web implementation.
 *
 * There is no interaction queue in the browser, so the closest equivalent is to
 * let the current frame paint before running the task.
 */
export interface ScheduledTask {
  cancel: () => void;
}

export const runAfterInteractions = (task: () => void): ScheduledTask => {
  const handle = requestAnimationFrame(() => task());
  return { cancel: () => cancelAnimationFrame(handle) };
};
